// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import cx from 'helpers/cx'
import { isSameTime } from 'helpers/date/showDate'
import { TabletUp } from 'helpers/MediaQuery'

import { DisplayDate } from 'js/components/DisplayDate'
import Flexer from 'js/components/Flexer/Flexer'
import Tag from 'js/components/Tag'
import Text from 'js/components/Text/Text'

import styles from './Activity.module.css'

type EntityType = {
    title: string
    url: string
    startDate: string
    endDate?: string
    slots?: string[]
    maxAttendees?: number
    attendees?: {
        totalAccept: number
    }
}

type Props = {
    entity: EntityType
    showSlots?: boolean
    showSpots?: boolean
    isFirst?: boolean
    isLast?: boolean
    children?: React.ReactNode
}

const Activity = ({
    entity,
    showSlots,
    showSpots,
    isFirst,
    isLast,
    children,
}: Props) => {
    const { t } = useTranslation()

    const {
        title,
        url,
        startDate,
        endDate,
        slots = [],
        maxAttendees,
        attendees: { totalAccept } = {},
    } = entity

    const sameTime = isSameTime(startDate, endDate)

    const hasSlots = showSlots && slots.length > 0
    const hasSpots = showSpots && maxAttendees

    const spotsLeft = maxAttendees - totalAccept

    return (
        <div
            className={cx(
                styles.wrapper,
                isFirst && styles.isFirst,
                isLast && styles.isLast,
            )}
        >
            <div className={styles.activityTime} aria-hidden>
                <DisplayDate date={startDate} type="time" />
                {!!endDate && !sameTime ? (
                    <>
                        <TabletUp>&nbsp;–&nbsp;</TabletUp>
                        <DisplayDate date={endDate} type="time" side="right" />
                    </>
                ) : null}
            </div>
            <Link
                to={url}
                state={{ prevPathname: location.pathname }}
                className={styles.activityLink}
            >
                <div className={styles.activityTitle}>{title}</div>
                {(hasSlots || hasSpots) && (
                    <Flexer
                        justifyContent="flex-start"
                        gutterSize="sm"
                        wrap
                        style={hasSlots ? { marginTop: '2px' } : {}}
                    >
                        {hasSlots && (
                            <Flexer
                                justifyContent="flex-start"
                                gutterSize="sm"
                                wrap
                            >
                                {slots.map((slot, i) => (
                                    <Tag
                                        key={`${slot}-${i}`}
                                        style={{
                                            marginTop: '2px',
                                            marginBottom: '2px',
                                        }}
                                    >
                                        {slot}
                                    </Tag>
                                ))}
                            </Flexer>
                        )}
                        {hasSpots && (
                            <Text size="small" variant="grey">
                                {spotsLeft > 0
                                    ? t('entity-event.spots-available', {
                                          count: spotsLeft,
                                      })
                                    : t('entity-event.guest-list-full')}
                            </Text>
                        )}
                    </Flexer>
                )}
            </Link>
            {children}
        </div>
    )
}

export default Activity
